"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$t = exports.translateTextNode = exports.translateTextWithParams = exports.translateText = exports.translateMessage = void 0;
const LogMessageDataType_1 = require("../LogMessageDataType");
const PreferencesManager_1 = require("../components/PreferencesManager");
const raw_translations = require("../genfiles/translations.json");
const Log_1 = require("../Log");
const TM_translations = raw_translations;
function translateMessage(message) {
    message.message = translateText(message.message);
    return Log_1.Log.applyData(message, (datum) => {
        if (datum !== undefined && datum.type === LogMessageDataType_1.LogMessageDataType.RAW_STRING) {
            return datum.value;
        }
        return '';
    });
}
exports.translateMessage = translateMessage;
function translateText(englishText) {
    let translatedText = englishText;
    const lang = PreferencesManager_1.PreferencesManager.load('lang') || 'en';
    if (lang === 'en')
        return englishText;
    englishText = normalizeText(englishText);
    const languages = TM_translations[englishText];
    if (languages !== undefined && languages[lang] !== undefined) {
        translatedText = languages[lang];
    }
    else {
        let stripedText = englishText.replace(/^\((.*)\)$/gm, '$1');
        if (stripedText && stripedText !== englishText) {
            stripedText = translateText(stripedText);
            if (stripedText !== englishText) {
                translatedText = '(' + stripedText + ')';
            }
        }
        else if (stripedText && stripedText.length > 3) {
            console.log('Please translate "' + stripedText + '"');
        }
    }
    return translatedText;
}
exports.translateText = translateText;
function translateTextWithParams(englishText, params) {
    const data = params.map((p) => {
        return {
            type: LogMessageDataType_1.LogMessageDataType.RAW_STRING,
            value: p,
        };
    });
    const message = {
        message: englishText,
        data: data,
    };
    return translateMessage(message);
}
exports.translateTextWithParams = translateTextWithParams;
function normalizeText(text) {
    return text.replace(/[\n\r]/g, '').replace(/[ ]+/g, ' ');
}
function translateChildren(node) {
    for (let i = 0, length = node.childNodes.length; i < length; i++) {
        const child = node.childNodes[i];
        if (child.nodeType === Node.TEXT_NODE) {
            const text = child;
            const translatedText = translateText(text.data);
            if (translatedText !== text.data) {
                text.data = translatedText;
            }
        }
        else {
            translateChildren(child);
        }
    }
}
function translateTextNode(el) {
    translateChildren(el);
}
exports.translateTextNode = translateTextNode;
const $t = function (msg) {
    if (!msg)
        return '';
    if (typeof (msg) === 'number')
        return msg.toString();
    if (typeof msg === 'string') {
        return translateText(msg);
    }
    return translateMessage(msg);
};
exports.$t = $t;
//# sourceMappingURL=i18n.js.map